$(function () {
    //Right to Left Open Menu
    if($('.navToggle').length > 0){
        $('.navToggle').on('click', function () {
            $('.sidebar-wrap').toggleClass('open-mobile-nav');            
            $('html').toggleClass('hidescroll');
        });
    };     
    
    
    //chat Message Click ot open Chat
    if($('.profile-button').length > 0){
        $('.profile-button').on('click', function () {
            $('.profile').toggleClass('open-profile-dropdown');           
        });
    }; 
});



$(document).ready(function() {
    // Click handler for the three dots
    $('.more-btn').on('click', function(e) {
        e.stopPropagation(); // Prevents document click from firing immediately
        
        const $currentMenu = $(this).siblings('.dropdown-menu');
        
        // Close any other open menus first
        $('.dropdown-menu').not($currentMenu).removeClass('show');
        
        // Toggle only the menu belonging to this row
        $currentMenu.toggleClass('show');
    });

    // Close menu if user clicks anywhere else on the page
    $(document).on('click', function() {
        $('.dropdown-menu').removeClass('show'); 
    });

    // Optional: Close menu when clicking an item (with NO alert)
    $('.dropdown-menu li').on('click', function() {
        $('.dropdown-menu').removeClass('show');
    });
});


